import { env } from 'core/config';

/* eslint-disable @typescript-eslint/no-var-requires */
const awsConfig = require(`./aws-config.${env.STAGE}.js`);

export { awsConfig };
